import { imagePath } from 'src/util/formatUrl';

import { categoryList_categoryList_children } from '../../queries/__generated__/categoryList';

import { CategoryItem } from './CategoryList';

export function cleanCategories(categories: categoryList_categoryList_children[]): CategoryItem[] {
    const featuredCategories = categories.map((category) => {
        return {
            image: imagePath(category.image),
            link: '/' + category.url_path,
            title: category.name || 'unknown',
            shortDescription: category.short_description,
        };
    });

    return featuredCategories;
}
